import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { forwardRef } from 'preact/compat';
import { BRAND_CLASSES } from '@/constants/theme';
/**
 * Common DatePicker component for date selection
 * Integrates with React Hook Form via forwardRef
 *
 * @example
 * ```tsx
 * <DatePicker
 *   label="Launch Date"
 *   required
 *   error={errors.launchDate?.message}
 *   {...register('launchDate', { required: 'Required' })}
 * />
 * ```
 */
export const DatePicker = forwardRef(({ label, required, error, helperText, containerClassName, className, ...props }, ref) => {
    const inputClasses = `
            w-full px-3 py-2 border rounded-lg
            ${BRAND_CLASSES.INPUT.NORMAL}
            [color-scheme:light] dark:[color-scheme:dark]
            focus:outline-none focus:ring-2 focus:border-transparent
            ${error
        ? BRAND_CLASSES.INPUT.ERROR
        : BRAND_CLASSES.FOCUS.PRIMARY}
            ${className || ''}
        `.trim().replace(/\s+/g, ' ');
    return (_jsxs("div", { className: containerClassName, children: [label && (_jsxs("label", { className: `block text-sm font-medium mb-2 ${BRAND_CLASSES.INPUT.LABEL}`, children: [label, required && _jsx("span", { className: BRAND_CLASSES.INPUT.REQUIRED, children: " *" })] })), _jsx("input", { ref: ref, type: "date", className: inputClasses, ...props }), error && (_jsx("p", { className: `mt-1 text-sm ${BRAND_CLASSES.INPUT.ERROR_TEXT}`, children: error })), !error && helperText && (_jsx("p", { className: `mt-1 text-sm ${BRAND_CLASSES.INPUT.HELPER}`, children: helperText }))] }));
});
DatePicker.displayName = 'DatePicker';
